import { useEffect, useState } from 'react';
import {useParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {STATUS_MODEL} from '../../../../../enums/statusEnum';
import {STATUS_MODEL_CARD} from "../../../Visitor/External/Model/Model";
import {GetPublicEventDetail} from "../../../../../reduxToolkit/EmployeeEvents/EmployeeEventsApi";
import {RESERVATION_STATUS_MODEL_CARD} from "../Model/Model";
/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const EventExternalApp = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { getPublicEventDetail } = useSelector((state) => state.EmployeeEventsSlice);
    const [visitorStatus, setVisitorStatus] = useState({ ...RESERVATION_STATUS_MODEL_CARD.PROCEED_WITH_REGISTRATION }); // visitor_status_id
    const statusId = getPublicEventDetail?.status?.id;

    /**
     * Gets the reservation data.
     */
    useEffect(() => {
        if(id){
            dispatch(GetPublicEventDetail(id));
        }
    }, [id]);

    /**
     * Control of badge and follow-up card assignments according to the defined variables.
     * Assignment of the month and day label, assignment of latitude and longitude to a useState.
     */

    useEffect(() => {
        if (getPublicEventDetail?.id) {
            if(parseInt(statusId) === STATUS_MODEL.CANCELED){
                setVisitorStatus({ ...STATUS_MODEL_CARD.CANCELED_BY_EMPLOYEE});
                return;
            }
        }
    }, [getPublicEventDetail]);

    return {
        t,
        getPublicEventDetail,
        visitorStatus,
    }
}

export default EventExternalApp
